import type { QualityProfile, QualityTier } from './types';

export const QUALITY_PROFILES: Readonly<Record<QualityTier, QualityProfile>> = {
  low: {
    tier: 'low',
    pixelRatioCap: 1,
    shadowMapSize: 512,
    shadows: false,
    particleMultiplier: 0.28,
    fogMultiplier: 0.85,
    textureSize: 128,
  },
  medium: {
    tier: 'medium',
    pixelRatioCap: 1.5,
    shadowMapSize: 1024,
    shadows: true,
    particleMultiplier: 0.62,
    fogMultiplier: 1,
    textureSize: 256,
  },
  high: {
    tier: 'high',
    pixelRatioCap: 2,
    shadowMapSize: 2048,
    shadows: true,
    particleMultiplier: 1,
    fogMultiplier: 1.08,
    textureSize: 512,
  },
};

export function chooseAutomaticQuality(): QualityTier {
  if (typeof navigator === 'undefined') return 'medium';
  const memory = (navigator as Navigator & { deviceMemory?: number }).deviceMemory ?? 4;
  const cores = navigator.hardwareConcurrency ?? 4;
  const pixelRatio = typeof window === 'undefined' ? 1 : window.devicePixelRatio;
  if (memory <= 2 || cores <= 2) return 'low';
  if (memory >= 8 && cores >= 8 && pixelRatio <= 2.5) return 'high';
  return 'medium';
}
